import type { MetaIcon } from "../constants/icon.constant";

export interface GradientIconProps {
  icon: MetaIcon;
  colors: string[];
}

export default function GradientIconBuilder(
  props: Readonly<GradientIconProps>
) {
  return (
    <svg
      width={props.icon.width}
      height={props.icon.height}
      viewBox={props.icon.viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path d={props.icon.path} fill="url(#paint0_linear_9_29925)" />
      <defs>
        <linearGradient
          id="paint0_linear_9_29925"
          x1={props.icon.width / 1.6}
          y1={props.icon.height / 4.8}
          x2={props.icon.width / 1.28}
          y2={props.icon.height / 1.28}
          gradientUnits="userSpaceOnUse">
          {props.colors.map((color, index) => {
            const offset =
              props.colors.length === 1
                ? "0%"
                : `${(index / (props.colors.length - 1)) * 100}%`;
            return <stop key={color} offset={offset} stopColor={color} />;
          })}
        </linearGradient>
      </defs>
    </svg>
  );
}
